import { take, takeEvery } from 'redux-saga/effects';
import { ADD_NOTIFICATION, INITIAL_AUTHENTICATION } from '../../actions/actionTypes';
import { Action } from '../../actions/commonActions';
import { Notification } from '../../models/notification';

/**
 * Plays sounds when new notifications are added.
 * @param action The action which invoked the saga.
 */
export function onAddNotificationSaga(action: Action<Notification>) {
  if (!action.payload) {
    return;
  }
}

export function* initNotificationSagas() {
  yield take(INITIAL_AUTHENTICATION);
  yield takeEvery(ADD_NOTIFICATION, onAddNotificationSaga);
}
